import css from "./accountDeletionBox.module.css";
import { Button, Text } from "@idg-web-platform/pulse";
import { AccountDeletionDialog } from "./accountDeletionDialog.tsx";
import { useState } from "preact/hooks";

export function AccountDeletionBox() {
  const [isAccountDeletionDialogOpen, setIsAccountDeletionDialogOpen] = useState(false);

  return (
    <>
      <div className={css.card}>
        <div className={css.cardHeader}>
          <strong className={css.cardHeading}>Kundenkonto löschen</strong>
        </div>
        <Text>
          Du kannst hier dein Kundenkonto löschen. Bitte beachte, dass deine CLUB-Mitgliedschaft
          dadurch ebenfalls beendet wird.
        </Text>
        <Button
          class={css.deleteButton}
          text={"Mein Kundenkonto löschen"}
          onClick={() => setIsAccountDeletionDialogOpen(true)}
          step={-1}
        />

        <AccountDeletionDialog
          isOpen={isAccountDeletionDialogOpen}
          onClose={() => setIsAccountDeletionDialogOpen(false)}
        />
      </div>
    </>
  );
}
